import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import { bindActionCreators } from "redux";
import { List } from "immutable";
import { CaseHistoryTable, CaseActionModals } from "./../../modules/cases/templates";
import CompanyLosService  from "./services/company-los-services";
import { Card, Row, Col, Statistic, Button, Icon} from "antd";
import moment from "moment";
import AddNewProgram from "../../forms/mpa-forms/add-new-program-drawer";
class CompaniesCasesDisplay extends React.Component {

    state = {
        casesList: new List([]),
        displayAddProgram: false,
        addProgramLaoder: false
    }

    componentDidMount() {
        CompanyLosService.caseSearchList(this.props.gstin).then(({ data }) => {
            this.setState({
                casesList: new List(data.results),
            });
        }).catch(() => {
            this.setState({
                fetchedCasesList: true
            });
        });
    }

    onCaseAction = (action, caseId)=> {
        this.listener(caseId, action);
    }
    registerListener = (listener) => {
        this.listener = listener;
    }

    handleAddProgramDrawer = () => {
        this.setState({
            displayAddProgram : !this.state.displayAddProgram
        })
    }

    
    
    createProgram = () => {}
    render() {
        return (<React.Fragment>
                <AddNewProgram 
                    visible = {this.state.displayAddProgram}
                    onClose = {this.handleAddProgramDrawer}
                    createNewProgram={this.addNewProgram}
                    fetchCompanyMpa={this.props.fetchCompanyMpa}
                    companyId={this.props.companyId}
                />
                <Row>
                <Col span="24" className="text-right">
                        <Button type="link" onClick={(this.handleAddProgramDrawer)} >
                            <Icon type={"plus"} />
                            Add New Program
                        </Button>
                    </Col>
                    {!this.props.allMpaDetails.get('data').length && <Col span="24" className="text-center redirect-link">
                       
                        <p> <Icon type="exclamation-circle" /> Please
                            Add Program
                        to get started!
                        </p>
                    </Col> }
                </Row>
                {this.props.allMpaDetails.get('data').map((_) => <Card className="mt-10" onClick={() => this.props.moveToSpecificTab("mpaRequest", _)}>
                     <Row>
                        
                     <Col span={4}>
                            <Statistic title="Case ID" className="statisticValue" value={_.getIn(["mpa_approval","action_detail", "id"])}/>
                        </Col>
                        <Col span={6}>
                            <Statistic title="Product Name" className="statisticValue" value={_.getProductName()} />
                        </Col>
                        <Col span={5}>
                            <Statistic title="Stage" className="statisticValue" value={_.getStageNameAllMpa()} precision={2} />
                        </Col>
                        <Col span={5}>
                            <Statistic title="Program Size" className="statisticValue" value={_.getIn(["mpa_approval", "proposed_program_size_in_cr"])} precision={2} />
                        </Col>
                        <Col span={4}>
                            <Statistic title="Date" className="statisticValue" value={moment(_.getIn(["mpa_approval", "action_detail" ,"current_action_task", "create_date"])).format("DD-MM-YYYY")} precision={2} />
                        </Col>
                    </Row>
                </Card>)}

            {/* <CaseActionModals listenerHandler={this.registerListener} />
            <CaseHistoryTable cases={this.state.casesList} updateCaseType={this.props.updateCaseType} /> */}
            
        </React.Fragment>);
    }
}

const mapStateToProps = (state, props) => ({
    gstin: state.companyLosProfiles.getIn(["profiles", props.companyId, "data", "gstin"])
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);


CompaniesCasesDisplay.propTypes = {
    cases: PropTypes.object,
    companyId: PropTypes.number,
    gstin: PropTypes.string,
    updateCaseType: PropTypes.func,
    allMpaDetails: PropTypes.list,
    fetchCompanyMpa: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompaniesCasesDisplay);